import { Directive } from "@angular/core";
import {
  AbstractControl,
  FormGroup,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from "@angular/forms";

export const compareReviewDateValidator: ValidatorFn = (
  control: FormGroup
): ValidationErrors | null => {
  const reviewFrom = control.get("ReviewFrom");
  const reviewTo = control.get("ReviewTo");
  if (
    reviewFrom &&
    reviewTo &&
    new Date(reviewFrom.value) > new Date(reviewTo.value)
  ) {
    return { checkReview: true };
  }

  const year1 = control.get("Year1");
  const year2 = control.get("Year2");
  if (
    year1 &&
    year2 &&
    year1.value &&
    year2.value &&
    year1.value > year2.value
  ) {
    return { checkYear: true };
  }

  return null;
};

@Directive({
  selector: "[appIdentityRevealed]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CompareReviewDateValidatorDirective,
      multi: true,
    },
  ],
})
export class CompareReviewDateValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    return compareReviewDateValidator(control);
  }
}
